


































import { Component, Prop, Vue } from "vue-property-decorator";
import { VIEWPOINT_API } from "@/api/ViewpointApi";
import { Urls } from "@/Urls";
import { getModule } from "vuex-module-decorators";
import Decisions from "@/store/modules/Decisions"
import Users from "@/store/modules/Users";

const decisionsModule = getModule(Decisions);
const usersModule = getModule(Users)

@Component({
    components: {},
})
export default class JoinDecision extends Vue {

    @Prop()
    decisionId!: string;

    @Prop()
    passcode!: string;


    private error = '';

    mounted() {
        this.joinDecision()
    }

    private async joinDecision() {
        if(usersModule.currentAuthUser == null) {
            Vue.$cookies.set('joinDecision', {
                decisionId: this.decisionId,
                passcode: this.passcode
            })
            // TODO: Look into this redirect when DRUPAL fully implemented
            this.$router.push(Urls.LOGIN)
        }
        let user = await usersModule.getCurrentAuthUser()
        try {
            // verify join decision
            await VIEWPOINT_API.joinDecision(this.decisionId, this.passcode, user.attributes.email);
            // Vue.$cookies.set('joinedDecisionId', this.decisionId);
            await decisionsModule.fetchDecisions();
            // await decisionsModule.selectDecision(this.decisionId);
            let urlPath = `${Urls.TEMPLATE_BUILDER}?decisionId=${this.decisionId}`;
            console.log(urlPath);
            this.$router.push(urlPath);
            await decisionsModule.selectDecision(this.decisionId)
            // if logged in, load the decision. if not logged in, send them to the login screen
            // sign up screen read the cookie..
        } catch (e) {
            if (e.response.status === 404) {
                this.error = "This invitation has either expired or does not belong to you."
            } else {
                this.error = JSON.stringify(e.response.data.message);
            }
        }

    }

}
